import { PencilLine, Sparkles } from "lucide-react";
import { useState, type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import { AiScheduleForm } from "./AiScheduleForm";

type ScheduleMode = "manual" | "ai";

const panelClass = "mt-3 data-[state=inactive]:hidden";

export function ScheduleModeTabs({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  const [mode, setMode] = useState<ScheduleMode>("manual");
  const showManual = () => setMode("manual");

  return (
    <Tabs value={mode} onValueChange={value => setMode(value as ScheduleMode)}>
      <TabsList variant="line" className="sticky top-0 z-20 w-full shrink-0 bg-white">
        <TabsTrigger value="manual" className="flex-1 gap-2"><PencilLine className="size-4" />{t("schedule.modeManual")}</TabsTrigger>
        <TabsTrigger value="ai" className="flex-1 gap-2"><Sparkles className="size-4" />{t("schedule.modeAi")}</TabsTrigger>
      </TabsList>
      <TabsContent value="manual" forceMount className={panelClass}>{children}</TabsContent>
      <TabsContent value="ai" forceMount className={panelClass}><AiScheduleForm onApplied={showManual} /></TabsContent>
    </Tabs>
  );
}
